import { render, staticRenderFns } from "./vtecxy.vue?vue&type=template&id=0893ab2e&"
import script from "./vtecxy.vue?vue&type=script&lang=js&"
export * from "./vtecxy.vue?vue&type=script&lang=js&"
import style0 from "./vtecxy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports